/** Pixel-based snap shared by pointer and keyboard shelf navigation. */
export function shelfSnapOffset(offset: number, velocity: number, stride: number, max: number) {
  if (stride <= 0 || max <= 0) return 0;
  const projected = offset + Math.max(-2, Math.min(2, velocity)) * 130;
  return Math.max(0, Math.min(max, Math.round(projected / stride) * stride));
}
